import React from 'react';

const ResponseBlock = ({ message, link, fileName, errors, fileType, ...props }) => {
  
  const downloadFile = fileType === 'zip' ? `${fileName}.zip` : `${fileName}.csv`;

  return (
    <div className={`text-center ${!message ? 'hidden' : ''}`}>
      <div className={`
        p-4 text-lg w-1/2 mx-auto mt-4 rounded-lg shadow border-t-4
        ${errors ? 'bg-red-100 border-red-500 text-red-500 font-bold' : 'bg-teal-100 border-teal-500 text-teal-900'} `}>
        {message && <h4>{message}</h4>}
      </div>
      <div>
        {link && (
          <a 
            className="w-full bg-emerald-50 text-emerald-700 
                       hover:bg-emerald-100 font-bold 
                       py-2 px-4 rounded" 
            href={link} 
            download={downloadFile}>
            {fileType === 'zip' ? 'Download Images' : 'Download CSV'}
          </a>
        )}
      </div>
    </div>
  );
};

export default ResponseBlock;